const categories = [
    { 
        name: "hanging_planters", 
        img: "https://i.imgur.com/UoIoFrF.jpg" 
    },
    {
        name: "decorative_mirrors",
        img: "https://i.imgur.com/3ywqXAe.jpg",
    },
    { 
        name: "wall_shelves", 
        img: "https://i.imgur.com/pdZwPq4.jpg" 
    },
    { 
        name: "metal_wall_art", 
        img: "https://i.imgur.com/UrQoxiW.png" 
    },
    {
        name: "wall_clocks",
        img: "https://i.imgur.com/UjYVKsO.jpg",
    },
    { 
        name: "lamps_lighting", 
        img: "https://i.imgur.com/be7dS6q.jpg" 
    },
   
];

export default categories;
